import type { FC } from "react";

import { Box, useStyleConfig } from "@hightouch/htui";

type Props = {
  keys: string[];
  isActive: boolean;
};

// Hidden from screen readers, which would read the keys into the row's name; rows name them with aria-keyshortcuts.
export const KeyHints: FC<Props> = ({ keys, isActive }) => {
  // htui doesn't export Kbd, and its theme is styled for the dark Tooltip.
  const kbdStyles = useStyleConfig("Kbd");
  return (
    <Box as="span" aria-hidden display="inline-flex" gap={0.5} flexShrink={0}>
      {keys.map((key) => (
        <Box
          as="kbd"
          key={key}
          sx={{
            ...kbdStyles,
            display: "inline-grid",
            placeItems: "center",
            bg: isActive ? "white" : "blackAlpha.04",
            color: isActive ? "text.secondary" : "text.tertiary",
            boxShadow: isActive ? "xs" : "none",
            fontFamily: "inherit",
            fontSize: "sm",
            fontWeight: "medium",
          }}
        >
          {key.length === 1 ? key.toUpperCase() : key}
        </Box>
      ))}
    </Box>
  );
};
